<div class="page-tile-menu-trigger hideonprint">

  <i class="fa fa-bars hideonprint" [matMenuTriggerFor]="pageTileMenu"
  [ngClass]="{ 'disabled': buttons?.length < 1 && !tileId }"></i>

</div>

<mat-menu #pageTileMenu="matMenu" class="page-tile-menu tree-node-menu" [ngClass]="{'editing-mode':editMode}">
  @for (button of buttons; track button) {
    @if (editMode || !button.class.includes('show-on-edit')) {
      @if (!['pivot-tile','model-pivot-tile', 'pivot-tile-ng'].includes(tileContent)) {
        @if (button.link===true) {
          <a [routerLink]="button.func" mat-menu-item class="menu-item">
            <i [class]="button.class" [matTooltip]=button.HoverOverHint></i>
            {{button.name}}
          </a>
        }
        @if (!button.link) {
          <button (click)="button.func($event)" [disabled]="button.disabled" mat-menu-item
            class="menu-item">
            <i [class]="button.class" [matTooltip]=button.HoverOverHint></i>
            {{button.name}}
          </button>
        }
      }
    }
  }
  @if (tileId && editMode) {
    <button (click)="copyTileClicked()" mat-menu-item class="menu-item">
      <i [class]="'fa fa-copy'" [matTooltip]="'Make a copy of this tile'"></i>
      Copy Tile
    </button>
  }
  @if (tileId) {
    <button (click)="refreshTileClicked()" mat-menu-item class="menu-item">
      <i [class]="'fa fa-refresh'" [matTooltip]="'Refresh all the data for this tile'"></i>
      Refresh Tile
    </button>
  }
</mat-menu>
